import React, {ReactElement, useEffect, useRef, useState} from 'react';
import './PatientRecallTimelineStyles.scss';
import EmailIcon from '@material-ui/icons/Email';
import SmsIcon from '@material-ui/icons/Sms';
import MessageIcon from '@material-ui/icons/Message';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import HelpIcon from '@material-ui/icons/Help';
import ErrorIcon from '@material-ui/icons/Error';
import CheckIcon from '@material-ui/icons/Check';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent
} from '@material-ui/lab';
import {
  AppSmsStatus,
  NotificationType,
  PatientRecallReminderStatusMapping,
  PatientRecallWellCheckStatusMapping,
  PatientRecallWellCheckStatusObj
} from '@shared/constants/Mapping';
import {useTranslation} from 'react-i18next';
import {
  // fetchAnalysis,
  fetchAnalysisByPatient,
  fetchHighlights,
  fetchFullAnalysis,
  markMilestoneComplete,
  fetchCategoryLabels
} from '@shared/services/PatientRecallService';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import HelperUtils from '@shared/utils/HelperUtils';
import moment from 'moment';
import {APP, BORDER_PRIMARY_COLOR} from 'src/style/variable';
import {
  Tooltip,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextareaAutosize,
  makeStyles,
  createStyles
} from '@material-ui/core';
import {textFieldStyles} from '../../Invoices/TableDataAndStyles';
import {Controller, useForm} from 'react-hook-form';
import ButtonLoader from '@components/system/ButtonLoader/ButtonLoader';
const confirmDialogStyle = makeStyles(() =>
  createStyles({
    title: {
      fontSize: '1.5rem',
      padding: '12px 0'
      // fontWeight: 'bold'
    },
    subtitle: {
      fontSize: '1rem',
      padding: '4px 0 12px'
    },
    actionWrapper: {
      display: 'flex !important',
      padding: '16px 24px 20px 24px'
    },
    description: {
      fontSize: '1rem',
      marginTop: '32px'
    },
    label: {
      marginTop: '0.5rem',
      marginBottom: '0.5rem'
    },
    helperText: {
      backgroundColor: APP.COLOR.BACKGROUND.WARNING,
      justifyContent: 'space-between',
      alignItems: 'center',
      display: 'flex',
      marginTop: '1rem',
      padding: '1rem'
    }
  })
);
const textArea = {
  width: '100%',
  borderColor: BORDER_PRIMARY_COLOR,
  borderRadius: '3pt',
  paddingTop: '1rem',
  paddingLeft: '0.8rem',
  fontFamily: APP.FONT_FAMILY.REGULAR,
  fontSize: '1rem',
  paddingBottom: '1rem'
};
interface PatientRecallTimelineProps {
  groupId: number;
  clinicId: number;
  patientId: number;
  categoryId?: number | string;
  selectedPatient: Array<string | number>;
}
const PatientRecallTimeline = (
  props: PatientRecallTimelineProps
): React.ReactElement => {
  const classes = textFieldStyles();
  const confirmClasses = confirmDialogStyle();
  const {t} = useTranslation();
  const {
    groupId,
    clinicId,
    patientId,
    categoryId,
    selectedPatient
  }: // FIXME: PROPS IS TYPED REMOVE ANY
  any = props;
  const [analysisCategoryId, setAnalysisCategoryId]: any = useState<number>(
    categoryId
  );
  const {enqueueSnackbar} = useSnackbar();
  const [isLoading, setIsLoading]: any = useState<boolean>(false);
  const ref: any = useRef();
  const [open, setOpen]: any = useState<boolean>(false);
  const [timelineData, setTimelineData] = useState<any>([]);
  const [showFullAnalysis, setShowFullAnalysis]: any = useState<boolean>(true);
  const [isTodayScrolled, setIsTodayScrolled]: any = useState<boolean>(false);
  const [selectedMilestone, setSelectedMilestone]: any = useState<any>({});
  const [categoryLabels, setCategoryLabels]: any = useState<any>({});
  const wellcheckStatusTypes = PatientRecallWellCheckStatusMapping.map(item => {
    item.name = t(item.name);
    return item;
  });
  const reminderStatusTypes = PatientRecallReminderStatusMapping.map(item => {
    item.name = t(item.name);
    item.label = t(item.label);
    return item;
  });
  const {control, handleSubmit} = useForm<{
    amount: number;
    reason: string;
  }>({
    mode: 'all'
  });
  const mapWellCheckStatus = (status: any) => {
    const [item] = wellcheckStatusTypes.filter(
      (item1: any) => status === item1.id
    );
    if (item) {
      return item;
    }
  };
  const mapReminderStatus = (status: any) => {
    const [item] = reminderStatusTypes.filter(
      (item1: any) => status === item1.id
    );
    if (item) {
      return item;
    }
  };
  // const printTimelinePage = () => {
  //   const doc: any = document;
  //   const printContents: any = doc.getElementById('printablediv').innerHTML;
  //   const contents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = contents;
  // };
  const getHighlightDescription = (status: any) => {
    if (status === PatientRecallWellCheckStatusObj.UPCOMING) {
      return categoryLabels['upcoming_well_check_visit'];
    } else if (status === PatientRecallWellCheckStatusObj.MISSED) {
      return categoryLabels['missed_well_check_visit'];
    } else if (status === PatientRecallWellCheckStatusObj.COMPLETED) {
      return t('PATIENT_RECALL.COMPLETED_MILESTONE_EVENT');
    }
  };
  const [highlights, setHighlights]: any = useState<any>([]);

  const getCategoryLabels = async (id: any) => {
    try {
      const response: any = await fetchCategoryLabels(groupId, clinicId, id);
      if (response.data) {
        setCategoryLabels(response.data);
      }
    } catch (error: any) {
      enqueueSnackbar(
        (error && error.message) || t('PATIENT_RECALL.CATEGORY_LABELS_ERROR'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };

  const getHighlights = async (id: any) => {
    try {
      const options: any = {category_id: id};
      const res1: any = await fetchHighlights(
        groupId,
        clinicId,
        patientId,
        options
      );
      if (res1?.data?.highlights) {
        setHighlights(res1.data.highlights);
      } else {
        setHighlights([]);
      }
    } catch (error: any) {
      enqueueSnackbar(
        (error && error.message) || t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };

  const getAnalysisData = async () => {
    try {
      setIsLoading(true);
      const options: any = {category_id: analysisCategoryId || ''};
      const res: any = await fetchAnalysisByPatient(
        groupId,
        clinicId,
        patientId,
        options
      );
      if (res?.data?.analysis) {
        setTimelineData(res.data.analysis);
        setShowFullAnalysis(true);
      } else {
        setTimelineData([]);
      }
      let locCategoryId = analysisCategoryId;
      // Set category ID Value
      if (
        (locCategoryId === null || locCategoryId === undefined) &&
        res?.data?.analysis?.length > 0
      ) {
        locCategoryId = res?.data?.analysis[0].category_id;
        setAnalysisCategoryId(locCategoryId);
      }
      // Fetch category labels & highlights
      if (locCategoryId !== null && locCategoryId !== undefined) {
        getCategoryLabels(locCategoryId);
        getHighlights(locCategoryId);
      }
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      enqueueSnackbar(
        (error && error.message) || t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };
  const viewFullAnalysis = async () => {
    try {
      // printTimelinePage();
      //  Call full analysis api
      const options: any = {category_id: analysisCategoryId};
      const res: any = await fetchFullAnalysis(
        groupId,
        clinicId,
        patientId,
        options
      );
      if (res?.data?.analysis) {
        setTimelineData(res.data.analysis);
        enqueueSnackbar(res.message, SnackBarConfig('s'));
      } else {
        setTimelineData([]);
      }
      setShowFullAnalysis(false);
    } catch (error: any) {
      setIsLoading(false);
      enqueueSnackbar(
        (error && error.message) || t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };
  const returnClassesBasedOnTimelineIndex = (index: any) => {
    const obj: any = {};
    if (index % 2 === 0) {
      obj.flex_direction_opposite = 'flex-row-reverse';
      obj.justify_content_flex = 'justify-content-flex-start';
      obj.margin = 'margin-right-2';
      obj.card_symbol_class = 'card-right-icon';
    } else {
      obj.flex_direction = 'flex-row-reverse';
      obj.justify_content_flex = 'justify-content-flex-end';
      obj.margin = 'margin-left-2';
      obj.card_symbol_class = 'card-left-icon';
    }
    return obj;
  };
  const findMilestoneOfToday = () => {
    const items = timelineData.filter(
      (item: any) => moment(item.milestone_date) > moment()
    );
    if (items.length > 0) {
      return items[0];
    }
    return null;
  };
  const clickMarkAsComplete = (analysis: any) => {
    setSelectedMilestone(analysis);
    setOpen(true);
  };
  const saveMarkAsCompleted = async (data: any) => {
    try {
      setIsLoading(true);
      const res = await markMilestoneComplete(
        selectedMilestone?.clinic_group_id,
        selectedMilestone?.clinic_id,
        selectedMilestone?.id,
        data.reason,
        {}
      );
      setIsLoading(false);
      setOpen(false);
      enqueueSnackbar(res?.message, SnackBarConfig('s'));
      getAnalysisData();
    } catch (error: any) {
      setIsLoading(false);
      enqueueSnackbar(
        (error && error.message) || t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };
  const renderNotificationTypeIcon = (type: any): ReactElement => {
    if (!type) {
      return <span />;
    } else if (type === NotificationType.SMS) {
      return (
        <Tooltip title={`${t('NOTIFICATION_TYPE.SMS')}`} placement="top">
          <SmsIcon style={{color: APP.COLOR.PRIMARY}} fontSize={'small'} />
        </Tooltip>
      );
    } else if (type === NotificationType.EMAIL) {
      return (
        <Tooltip title={`${t('NOTIFICATION_TYPE.EMAIL')}`} placement="top">
          <EmailIcon style={{color: APP.COLOR.PRIMARY}} fontSize={'small'} />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={`${t('NOTIFICATION_TYPE.OTHER')}`} placement="top">
          <MessageIcon style={{color: APP.COLOR.PRIMARY}} fontSize={'small'} />
        </Tooltip>
      );
    }
  };
  const renderNotificationStatusIcon = (
    status: any,
    error?: string
  ): ReactElement => {
    if (!status) {
      return <span />;
    } else if (status === AppSmsStatus.PENDING) {
      return (
        <Tooltip title={`${t('SMS_STATUSES.PENDING')}`} placement="left">
          <HourglassFullIcon
            style={{color: APP.STATUS.WARNING}}
            fontSize={'small'}
          />
        </Tooltip>
      );
    } else if (status === AppSmsStatus.SENT) {
      return (
        <Tooltip title={`${t('SMS_STATUSES.SENT')}`} placement="left">
          <CheckIcon style={{color: APP.STATUS.SUCCESS}} fontSize={'small'} />
        </Tooltip>
      );
    } else if (status === AppSmsStatus.FAILED) {
      return (
        <Tooltip
          title={`${error ? error : t('SMS_STATUSES.FAILED')}`}
          placement="left">
          <ErrorIcon style={{color: APP.STATUS.ERROR}} fontSize={'small'} />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={`${t('SMS_STATUSES.UNKNOWN')}`} placement="left">
          <HelpIcon style={{color: APP.STATUS.DEFAULT}} fontSize={'small'} />
        </Tooltip>
      );
    }
  };
  useEffect(() => {
    getAnalysisData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (ref && ref.current && !isTodayScrolled) {
      ref.current.scrollIntoView({behavior: 'smooth', block: 'start'});
      setIsTodayScrolled(true);
    }
  }, [timelineData]); // eslint-disable-line react-hooks/exhaustive-deps
  const renderTimelineCard = (item: any, index: any) => {
    return (
      <TimelineItem
        style={{
          minHeight: index === timelineData.length - 1 ? '21rem' : '24rem'
        }}
        className={[
          'timeline-card-item',
          returnClassesBasedOnTimelineIndex(index).flex_direction
        ].join(' ')}>
        <TimelineContent
          className={[
            returnClassesBasedOnTimelineIndex(index).flex_direction
          ].join(' ')}>
          <div
            className={['timeline-card'].join(' ')}
            style={{
              borderTop: `2.8px solid ${mapWellCheckStatus(item.status)?.color}`
            }}>
            <div className="card-title">
              {item?.system_config
                ? item.system_config.short_description
                : item.org_config.short_description}
            </div>
            <div className="card-sub-title">
              {item?.system_config
                ? item.system_config.long_description
                : item.org_config.long_description}
            </div>
            <div className="card-status-section">
              <div className="status-1">{`${t('PATIENT_RECALL.STATUS')}:`}</div>
              <div className="status-2">
                {mapWellCheckStatus(item.status)?.name}
              </div>
              {item.status === PatientRecallWellCheckStatusObj.MISSED &&
                item.id && (
                  <div
                    onClick={() => {
                      clickMarkAsComplete(item);
                    }}
                    className={[
                      classes.primaryTextColor,
                      classes.patientNameStyles
                    ].join(' ')}
                    style={{display: 'flex'}}>
                    <p>{t('PATIENT_RECALL.MARK_AS_COMPLETE')}</p>
                  </div>
                )}
            </div>
            {item.milestone_completed_text && (
              <div className="complete-text">
                {`${t('PATIENT_RECALL.REASON')}: ${
                  item.milestone_completed_text
                }`}
              </div>
            )}
            <div className="card-reminders-section">
              <div style={{display: 'flex'}}>
                <div className="reminder-label">
                  {`${t('PATIENT_RECALL.REMINDERS_STATUS')}:`}
                </div>
                {!item.reminders ||
                  (item.reminders &&
                    Array.isArray(item.reminders) &&
                    item.reminders.length === 0 && <div>{'-'}</div>)}
              </div>
              {item.reminders &&
                Array.isArray(item.reminders) &&
                item.reminders.length > 0 &&
                item.reminders.map((item1: any, index1: any) => (
                  <div key={index1} className="reminder-header">
                    {renderNotificationTypeIcon(NotificationType.SMS)}
                    <div className="reminder-item-label">
                      {HelperUtils.formatDisplayDate(item1.reminder_date)}
                    </div>
                    {renderNotificationStatusIcon(item1.status)}
                    <div className="reminder-status">
                      {mapReminderStatus(item1.status)?.label}
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div
            className={[
              returnClassesBasedOnTimelineIndex(index).card_symbol_class,
              returnClassesBasedOnTimelineIndex(index).margin
            ].join(' ')}
          />
        </TimelineContent>
        <TimelineSeparator>
          <TimelineDot
            className={'timeline-dot'}
            style={{backgroundColor: mapWellCheckStatus(item.status)?.color}}
          />
          <TimelineConnector
            style={{
              background:
                moment(item.milestone_date) > moment() ? '#ADD8E6' : ''
            }}
            className="timeline-connector"
          />
        </TimelineSeparator>
        <TimelineOppositeContent
          className={[
            'timeline-opposite-content',
            returnClassesBasedOnTimelineIndex(index).justify_content_flex,
            returnClassesBasedOnTimelineIndex(index).padding_opposite
          ].join(' ')}>
          <div
            className={[
              'milestone-date-section',
              returnClassesBasedOnTimelineIndex(index).flex_direction_opposite
            ].join(' ')}>
            <div className="opposite-label">
              {HelperUtils.formatDisplayDate(item.milestone_date)}
            </div>
            <div className="opposite-line" />
          </div>
        </TimelineOppositeContent>
      </TimelineItem>
    );
  };
  const renderDialog = () => {
    return (
      <Dialog
        maxWidth={'sm'}
        fullWidth
        open={open}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        onClose={(): void => {
          setOpen(false);
        }}
        aria-labelledby="confirm-dialog"
        aria-describedby="confirm-dialog">
        <DialogTitle disableTypography>{'Reason'}</DialogTitle>
        <DialogContent dividers>
          <div className={confirmClasses.label}>
            {t('PATIENT_RECALL.REASON_TO_MARK_COMPLETE')}*
          </div>
          <FormControl fullWidth={true} variant="outlined">
            <Controller
              id="reason"
              as={
                <TextareaAutosize
                  rowsMax={10}
                  rows={4}
                  aria-label="maximum height"
                  placeholder={t(
                    'PATIENT_RECALL.ENTER_REASON_TO_MARK_COMPLETE'
                  )}
                  style={textArea}
                />
              }
              margin={'dense'}
              control={control}
              name={'reason'}
              type={'text'}
              value={'text'}
              autoComplete="on"
            />
          </FormControl>
        </DialogContent>
        <DialogActions style={{display: 'flex'}}>
          <Button
            disabled={isLoading}
            onClick={() => {
              setOpen(false);
            }}>
            {isLoading ? <ButtonLoader /> : t('COMMON.CANCEL')}
          </Button>
          <Button
            disabled={isLoading}
            variant="contained"
            type="submit"
            color="primary"
            onClick={handleSubmit(saveMarkAsCompleted)}>
            {isLoading ? <ButtonLoader /> : t('COMMON.SUBMIT')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  const renderTodayTimelineCard = () => {
    return (
      <TimelineItem
        ref={ref}
        className={['timeline-card-today-item'].join(' ')}>
        <TimelineContent className={['left-line-section'].join(' ')}>
          <div className="line-1" />
          <div className="line-2">
            {t('PATIENT_RECALL.TODAY', {
              today_date: HelperUtils.formatDisplayDate(moment())
            })}
          </div>
          <div className="line-3" />
        </TimelineContent>
        <TimelineSeparator>
          <TimelineDot
            className={'timeline-dot'}
            style={{backgroundColor: APP.COLOR.PRIMARY}}
          />
          <TimelineConnector className="timeline-connector" />
        </TimelineSeparator>
        <TimelineOppositeContent className={['left-line-section'].join(' ')}>
          <div className="line-4" />
        </TimelineOppositeContent>
      </TimelineItem>
    );
  };
  return (
    <div className="recall-timeline-wrapper" id="recall-timeline">
      <div className="top-section">
        <div className="left-section">
          <div className="top-section-label">
            {/** FIXME: No dob required */}
            {t('PATIENT_RECALL.WELLNESS_TIMELINE', {
              age: selectedPatient.age
            })}
          </div>
        </div>
        <div className="right-section">
          {wellcheckStatusTypes.map(item => (
            <div key={item.id} className="status-section">
              <div
                className="bullet-section"
                style={{background: mapWellCheckStatus(item.id)?.color}}
              />
              <div
                className="label-section"
                style={{color: mapWellCheckStatus(item.id)?.color}}>
                {item.name}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="timeline-parent-wrapper">
        <div className="timeline-section-wrapper">
          {timelineData &&
            Array.isArray(timelineData) &&
            timelineData.length > 0 && (
              <Timeline align="alternate" className="timeline-section">
                {timelineData.map((item: any, index) => {
                  return (
                    <div key={index}>
                      <div>
                        {findMilestoneOfToday() &&
                          findMilestoneOfToday().id === item.id &&
                          renderTodayTimelineCard()}
                      </div>
                      <div>{renderTimelineCard(item, index)}</div>
                      {showFullAnalysis && index === timelineData.length - 1 && (
                        <div
                          className="view-analysis"
                          onClick={(e: any) => {
                            viewFullAnalysis();
                          }}>
                          {t('PATIENT_RECALL.VIEW_MORE')}
                        </div>
                      )}
                    </div>
                  );
                })}
              </Timeline>
            )}
          {!isLoading &&
            Array.isArray(timelineData) &&
            timelineData.length === 0 && (
              <div className="timeline-section no-timeline-label">
                {t('PATIENT_RECALL.NO_TIMELINE_FOUND')}
              </div>
            )}
        </div>
        <div className="highlights-wrapper">
          <div className="highlights-header">
            <div className="header-label">{t('PATIENT_RECALL.HIGHLIGHTS')}</div>
          </div>
          <div className="highlights-body">
            {!isLoading &&
              highlights.map((item1: any, index: number) => (
                <div key={item1.id} className="highlight-item">
                  {index !== 0 && <div className="divider" />}
                  <div className="date-section">
                    <div
                      className="date-color"
                      style={{
                        background: mapWellCheckStatus(item1.status)?.color
                      }}
                    />
                    <div className="date-label">
                      {HelperUtils.formatDisplayDate(item1.milestone_date)}
                    </div>
                  </div>
                  <div className="highlight-title">
                    {item1.system_config
                      ? item1.system_config.short_description
                      : item1.org_config.short_description}
                  </div>
                  <div className="highlight-sub-title">
                    {getHighlightDescription(item1.status)}
                  </div>
                </div>
              ))}
            {!isLoading && highlights.length === 0 && (
              <div>{t('PATIENT_RECALL.NO_HIGHLIGHTS')}</div>
            )}
          </div>
        </div>
      </div>
      {open && renderDialog()}
    </div>
  );
};
export default PatientRecallTimeline;
